import React from 'react'
import { WHO_CAN_SELL, GETTING_STARTED_LINK } from '../../helpers/constants'
import type { SectionProps } from './Section'
import Section from './Section'

const Component = (props: SectionProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { currentSection, onToggle, section } = props
  return (
    <Section
      name={WHO_CAN_SELL}
      title='Can anyone sell on Saatchi Art'
      {...{
        currentSection,
        onToggle,
        section,
      }}
    >
      <p>
        Saatchi Art supports the work of all emerging artists. If you are at least 18 years of age,
        then you can sell your art on Saatchi Art. If you have gallery representation, we’re still
        happy to have you on Saatchi Art, as we are a non-exclusive online gallery.{' '}
        <a data-type='link' target='_blank' rel='noopener noreferrer' href={GETTING_STARTED_LINK}>
          Learn More
        </a>
      </p>
    </Section>
  )
}

export default Component